import { render, staticRenderFns } from "./ShiftAgencyDetails.vue?vue&type=template&id=06f63c87&"
import script from "./ShiftAgencyDetails.vue?vue&type=script&lang=js&"
export * from "./ShiftAgencyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports